module.exports = __webpack_public_path__ + "static/badge-trial-150x150-2ceb2f3f236fad25a8dc4a2fbbf97941.png";